(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-dr-confianza"] && !Shopify.designMode) return;
  try {
    
!function(){function e(e){e.dataset.hfMounted||(e.dataset.hfMounted="1",e.querySelectorAll("[data-review-tab]").forEach(function(t){t.onclick=function(){e.querySelectorAll("[data-review-tab]").forEach(function(e){e.classList.toggle("active",e===t),e.setAttribute("aria-selected",e===t)}),e.querySelectorAll("[data-review-panel]").forEach(function(e){e.classList.toggle("active",e.dataset.reviewPanel===t.dataset.reviewTab)})}}),e.querySelectorAll(".section3_icons_lp .icons_with_text_item,.faq_slider_item").forEach(function(t){var o=t.querySelector(".icons_with_text_item_flex,.faq_question"),r=t.querySelector(".icons_with_text_item_text,.faq_answer");function i(){var r=!t.classList.contains("active");e.querySelectorAll(".section3_icons_lp .icons_with_text_item,.faq_slider_item").forEach(function(e){e.classList.remove("active");var t=e.querySelector("[role=button]");t&&t.setAttribute("aria-expanded","false")}),t.classList.toggle("active",r),o.setAttribute("aria-expanded",r)}o&&r&&(o.setAttribute("role","button"),o.setAttribute("tabindex","0"),o.setAttribute("aria-expanded","false"),o.onclick=i,o.onkeydown=function(e){"Enter"!==e.key&&" "!==e.key||(e.preventDefault(),i())})}),e.querySelectorAll(".custom_slick_slider,.rt-swiper .swiper-wrapper,.flow-ritual__mobile .swiper-wrapper").forEach(function(e){e.classList.add("hf-native");var t=e.closest("[data-review-panel]")||e.closest(".rt-shell,.flow-ritual__mobile")||e.parentNode.parentNode,o=t.querySelector(".custom_prev,.rt-nav-btn-prev,.flow-ritual__arrow--prev"),r=t.querySelector(".custom_next,.rt-nav-btn-next,.flow-ritual__arrow--next"),i=t.querySelector(".slider_dots_custom"),l=Array.from(e.children);function a(t){var o=l[0]?l[0].getBoundingClientRect().width+20:300,r=e.scrollLeft+t*o;r>e.scrollWidth-e.clientWidth+10&&(r=0),r<0&&(r=e.scrollWidth),e.scrollTo({left:r,behavior:matchMedia("(prefers-reduced-motion:reduce)").matches?"auto":"smooth"})}if(o&&(o.onclick=function(){a(-1)}),r&&(r.onclick=function(){a(1)}),i){function c(){var t=l[0]?l[0].getBoundingClientRect().width+20:300,o=Math.round(e.scrollLeft/t);Array.from(i.children).forEach(function(e,t){e.classList.toggle("active",t===o)})}i.innerHTML="",l.forEach(function(t,o){var r=document.createElement("button");r.setAttribute("aria-label","Slide "+(o+1)),r.onclick=function(){e.scrollTo({left:t.offsetLeft-e.offsetLeft,behavior:"smooth"})},i.appendChild(r)}),e.onscroll=c,c()}}),e.querySelectorAll("video").forEach(function(e){e.controls=!0;var t=e.closest(".video_wrapper_custom");if(t){var o=t.querySelector(".custom_button");o&&(o.onclick=function(){t.classList.add("video-active"),e.play()})}}),e.querySelectorAll(".count_js").forEach(function(e){e.textContent=e.dataset.value||e.textContent}))}customElements.get("herbalia-liquid-08")||customElements.define("herbalia-liquid-08",class extends HTMLElement{connectedCallback(){var t=this;requestAnimationFrame(function(){e(t)})}}),document.querySelectorAll("herbalia-liquid-08").forEach(e)}();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-dr-frena"] && !Shopify.designMode) return;
  try {
    
!function(){function e(e){e.dataset.hfMounted||(e.dataset.hfMounted="1",e.querySelectorAll("[data-review-tab]").forEach(function(t){t.onclick=function(){e.querySelectorAll("[data-review-tab]").forEach(function(e){e.classList.toggle("active",e===t),e.setAttribute("aria-selected",e===t)}),e.querySelectorAll("[data-review-panel]").forEach(function(e){e.classList.toggle("active",e.dataset.reviewPanel===t.dataset.reviewTab)})}}),e.querySelectorAll(".section3_icons_lp .icons_with_text_item,.faq_slider_item").forEach(function(t){var o=t.querySelector(".icons_with_text_item_flex,.faq_question"),r=t.querySelector(".icons_with_text_item_text,.faq_answer");function i(){var r=!t.classList.contains("active");e.querySelectorAll(".section3_icons_lp .icons_with_text_item,.faq_slider_item").forEach(function(e){e.classList.remove("active");var t=e.querySelector("[role=button]");t&&t.setAttribute("aria-expanded","false")}),t.classList.toggle("active",r),o.setAttribute("aria-expanded",r)}o&&r&&(o.setAttribute("role","button"),o.setAttribute("tabindex","0"),o.setAttribute("aria-expanded","false"),o.onclick=i,o.onkeydown=function(e){"Enter"!==e.key&&" "!==e.key||(e.preventDefault(),i())})}),e.querySelectorAll(".custom_slick_slider,.rt-swiper .swiper-wrapper,.flow-ritual__mobile .swiper-wrapper").forEach(function(e){e.classList.add("hf-native");var t=e.closest("[data-review-panel]")||e.closest(".rt-shell,.flow-ritual__mobile")||e.parentNode.parentNode,o=t.querySelector(".custom_prev,.rt-nav-btn-prev,.flow-ritual__arrow--prev"),r=t.querySelector(".custom_next,.rt-nav-btn-next,.flow-ritual__arrow--next"),i=t.querySelector(".slider_dots_custom"),l=Array.from(e.children);function a(t){var o=l[0]?l[0].getBoundingClientRect().width+20:300,r=e.scrollLeft+t*o;r>e.scrollWidth-e.clientWidth+10&&(r=0),r<0&&(r=e.scrollWidth),e.scrollTo({left:r,behavior:matchMedia("(prefers-reduced-motion:reduce)").matches?"auto":"smooth"})}if(o&&(o.onclick=function(){a(-1)}),r&&(r.onclick=function(){a(1)}),i){function c(){var t=l[0]?l[0].getBoundingClientRect().width+20:300,o=Math.round(e.scrollLeft/t);Array.from(i.children).forEach(function(e,t){e.classList.toggle("active",t===o)})}i.innerHTML="",l.forEach(function(t,o){var r=document.createElement("button");r.setAttribute("aria-label","Slide "+(o+1)),r.onclick=function(){e.scrollTo({left:t.offsetLeft-e.offsetLeft,behavior:"smooth"})},i.appendChild(r)}),e.onscroll=c,c()}}),e.querySelectorAll("video").forEach(function(e){e.controls=!0;var t=e.closest(".video_wrapper_custom");if(t){var o=t.querySelector(".custom_button");o&&(o.onclick=function(){t.classList.add("video-active"),e.play()})}}),e.querySelectorAll(".count_js").forEach(function(e){e.textContent=e.dataset.value||e.textContent}))}customElements.get("herbalia-liquid-06")||customElements.define("herbalia-liquid-06",class extends HTMLElement{connectedCallback(){var t=this;requestAnimationFrame(function(){e(t)})}}),document.querySelectorAll("herbalia-liquid-06").forEach(e)}();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-dr-garantia"] && !Shopify.designMode) return;
  try {
    
!function(){function e(e){e.dataset.hfMounted||(e.dataset.hfMounted="1",e.querySelectorAll("[data-review-tab]").forEach(function(t){t.onclick=function(){e.querySelectorAll("[data-review-tab]").forEach(function(e){e.classList.toggle("active",e===t),e.setAttribute("aria-selected",e===t)}),e.querySelectorAll("[data-review-panel]").forEach(function(e){e.classList.toggle("active",e.dataset.reviewPanel===t.dataset.reviewTab)})}}),e.querySelectorAll(".section3_icons_lp .icons_with_text_item,.faq_slider_item").forEach(function(t){var o=t.querySelector(".icons_with_text_item_flex,.faq_question"),r=t.querySelector(".icons_with_text_item_text,.faq_answer");function i(){var r=!t.classList.contains("active");e.querySelectorAll(".section3_icons_lp .icons_with_text_item,.faq_slider_item").forEach(function(e){e.classList.remove("active");var t=e.querySelector("[role=button]");t&&t.setAttribute("aria-expanded","false")}),t.classList.toggle("active",r),o.setAttribute("aria-expanded",r)}o&&r&&(o.setAttribute("role","button"),o.setAttribute("tabindex","0"),o.setAttribute("aria-expanded","false"),o.onclick=i,o.onkeydown=function(e){"Enter"!==e.key&&" "!==e.key||(e.preventDefault(),i())})}),e.querySelectorAll(".custom_slick_slider,.rt-swiper .swiper-wrapper,.flow-ritual__mobile .swiper-wrapper").forEach(function(e){e.classList.add("hf-native");var t=e.closest("[data-review-panel]")||e.closest(".rt-shell,.flow-ritual__mobile")||e.parentNode.parentNode,o=t.querySelector(".custom_prev,.rt-nav-btn-prev,.flow-ritual__arrow--prev"),r=t.querySelector(".custom_next,.rt-nav-btn-next,.flow-ritual__arrow--next"),i=t.querySelector(".slider_dots_custom"),l=Array.from(e.children);function a(t){var o=l[0]?l[0].getBoundingClientRect().width+20:300,r=e.scrollLeft+t*o;r>e.scrollWidth-e.clientWidth+10&&(r=0),r<0&&(r=e.scrollWidth),e.scrollTo({left:r,behavior:matchMedia("(prefers-reduced-motion:reduce)").matches?"auto":"smooth"})}if(o&&(o.onclick=function(){a(-1)}),r&&(r.onclick=function(){a(1)}),i){function c(){var t=l[0]?l[0].getBoundingClientRect().width+20:300,o=Math.round(e.scrollLeft/t);Array.from(i.children).forEach(function(e,t){e.classList.toggle("active",t===o)})}i.innerHTML="",l.forEach(function(t,o){var r=document.createElement("button");r.setAttribute("aria-label","Slide "+(o+1)),r.onclick=function(){e.scrollTo({left:t.offsetLeft-e.offsetLeft,behavior:"smooth"})},i.appendChild(r)}),e.onscroll=c,c()}}),e.querySelectorAll("video").forEach(function(e){e.controls=!0;var t=e.closest(".video_wrapper_custom");if(t){var o=t.querySelector(".custom_button");o&&(o.onclick=function(){t.classList.add("video-active"),e.play()})}}),e.querySelectorAll(".count_js").forEach(function(e){e.textContent=e.dataset.value||e.textContent}))}customElements.get("herbalia-liquid-15")||customElements.define("herbalia-liquid-15",class extends HTMLElement{connectedCallback(){var t=this;requestAnimationFrame(function(){e(t)})}}),document.querySelectorAll("herbalia-liquid-15").forEach(e)}();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-dr-preguntas"] && !Shopify.designMode) return;
  try {
    

(function(){
 function init(sec){
  if(sec.hbFaqCleanup)return;
  var items=Array.prototype.slice.call(sec.querySelectorAll('details.faq_slider_item'));
  var states=[],reduced=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  function setOpen(state,open){
   var item=state.item,start=item.getBoundingClientRect().height;
   state.desired=open;if(state.animation){state.animation.cancel();state.animation=null;}
   item.style.height='';item.style.overflow='hidden';
   if(open){item.open=true;states.forEach(function(other){if(other!==state&&(other.desired||other.item.open))setOpen(other,false);});}
   var end=open?item.getBoundingClientRect().height:state.summary.getBoundingClientRect().height+item.offsetHeight-item.clientHeight;
   state.summary.setAttribute('aria-expanded',String(open));
   function finish(){item.open=open;item.style.height='';item.style.overflow='';state.animation=null;}
   if(reduced||!item.animate){finish();return;}
   item.style.height=start+'px';
   state.animation=item.animate({height:[start+'px',end+'px']},{duration:280,easing:'cubic-bezier(.2,.65,.3,1)'});
   state.animation.onfinish=finish;
  }
  items.forEach(function(item){
   var summary=item.querySelector('summary');if(!summary)return;
   var state={item:item,summary:summary,desired:item.open,animation:null};states.push(state);
   summary.setAttribute('aria-expanded',String(item.open));
   state.click=function(e){e.preventDefault();setOpen(state,!state.desired);};summary.addEventListener('click',state.click);
  });
  sec.hbFaqCleanup=function(){states.forEach(function(state){if(state.animation)state.animation.cancel();state.summary.removeEventListener('click',state.click);state.item.style.height='';state.item.style.overflow='';});sec.hbFaqCleanup=null;};
 }
 function start(scope){if(scope.matches&&scope.matches('herbalia-liquid-14'))init(scope);scope.querySelectorAll('herbalia-liquid-14').forEach(init);}
 start(document);document.addEventListener('shopify:section:load',function(e){start(e.target);});
 document.addEventListener('shopify:section:unload',function(e){e.target.querySelectorAll('herbalia-liquid-14').forEach(function(sec){if(sec.hbFaqCleanup)sec.hbFaqCleanup();});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-dr-proceso"] && !Shopify.designMode) return;
  try {
    
!function(){function e(e){e.dataset.hfMounted||(e.dataset.hfMounted="1",e.querySelectorAll("[data-review-tab]").forEach(function(t){t.onclick=function(){e.querySelectorAll("[data-review-tab]").forEach(function(e){e.classList.toggle("active",e===t),e.setAttribute("aria-selected",e===t)}),e.querySelectorAll("[data-review-panel]").forEach(function(e){e.classList.toggle("active",e.dataset.reviewPanel===t.dataset.reviewTab)})}}),e.querySelectorAll(".section3_icons_lp .icons_with_text_item,.faq_slider_item").forEach(function(t){var o=t.querySelector(".icons_with_text_item_flex,.faq_question"),r=t.querySelector(".icons_with_text_item_text,.faq_answer");function i(){var r=!t.classList.contains("active");e.querySelectorAll(".section3_icons_lp .icons_with_text_item,.faq_slider_item").forEach(function(e){e.classList.remove("active");var t=e.querySelector("[role=button]");t&&t.setAttribute("aria-expanded","false")}),t.classList.toggle("active",r),o.setAttribute("aria-expanded",r)}o&&r&&(o.setAttribute("role","button"),o.setAttribute("tabindex","0"),o.setAttribute("aria-expanded","false"),o.onclick=i,o.onkeydown=function(e){"Enter"!==e.key&&" "!==e.key||(e.preventDefault(),i())})}),e.querySelectorAll(".custom_slick_slider,.rt-swiper .swiper-wrapper,.flow-ritual__mobile .swiper-wrapper").forEach(function(e){e.classList.add("hf-native");var t=e.closest("[data-review-panel]")||e.closest(".rt-shell,.flow-ritual__mobile")||e.parentNode.parentNode,o=t.querySelector(".custom_prev,.rt-nav-btn-prev,.flow-ritual__arrow--prev"),r=t.querySelector(".custom_next,.rt-nav-btn-next,.flow-ritual__arrow--next"),i=t.querySelector(".slider_dots_custom"),l=Array.from(e.children);function a(t){var o=l[0]?l[0].getBoundingClientRect().width+20:300,r=e.scrollLeft+t*o;r>e.scrollWidth-e.clientWidth+10&&(r=0),r<0&&(r=e.scrollWidth),e.scrollTo({left:r,behavior:matchMedia("(prefers-reduced-motion:reduce)").matches?"auto":"smooth"})}if(o&&(o.onclick=function(){a(-1)}),r&&(r.onclick=function(){a(1)}),i){function c(){var t=l[0]?l[0].getBoundingClientRect().width+20:300,o=Math.round(e.scrollLeft/t);Array.from(i.children).forEach(function(e,t){e.classList.toggle("active",t===o)})}i.innerHTML="",l.forEach(function(t,o){var r=document.createElement("button");r.setAttribute("aria-label","Slide "+(o+1)),r.onclick=function(){e.scrollTo({left:t.offsetLeft-e.offsetLeft,behavior:"smooth"})},i.appendChild(r)}),e.onscroll=c,c()}}),e.querySelectorAll("video").forEach(function(e){e.controls=!0;var t=e.closest(".video_wrapper_custom");if(t){var o=t.querySelector(".custom_button");o&&(o.onclick=function(){t.classList.add("video-active"),e.play()})}}),e.querySelectorAll(".count_js").forEach(function(e){e.textContent=e.dataset.value||e.textContent}))}customElements.get("herbalia-liquid-03")||customElements.define("herbalia-liquid-03",class extends HTMLElement{connectedCallback(){var t=this;requestAnimationFrame(function(){e(t)})}}),document.querySelectorAll("herbalia-liquid-03").forEach(e)}();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-dr-razones"] && !Shopify.designMode) return;
  try {
    
!function(){function e(e){e.dataset.hfMounted||(e.dataset.hfMounted="1",e.querySelectorAll("[data-review-tab]").forEach(function(t){t.onclick=function(){e.querySelectorAll("[data-review-tab]").forEach(function(e){e.classList.toggle("active",e===t),e.setAttribute("aria-selected",e===t)}),e.querySelectorAll("[data-review-panel]").forEach(function(e){e.classList.toggle("active",e.dataset.reviewPanel===t.dataset.reviewTab)})}}),e.querySelectorAll(".section3_icons_lp .icons_with_text_item,.faq_slider_item").forEach(function(t){var o=t.querySelector(".icons_with_text_item_flex,.faq_question"),r=t.querySelector(".icons_with_text_item_text,.faq_answer");function i(){var r=!t.classList.contains("active");e.querySelectorAll(".section3_icons_lp .icons_with_text_item,.faq_slider_item").forEach(function(e){e.classList.remove("active");var t=e.querySelector("[role=button]");t&&t.setAttribute("aria-expanded","false")}),t.classList.toggle("active",r),o.setAttribute("aria-expanded",r)}o&&r&&(o.setAttribute("role","button"),o.setAttribute("tabindex","0"),o.setAttribute("aria-expanded","false"),o.onclick=i,o.onkeydown=function(e){"Enter"!==e.key&&" "!==e.key||(e.preventDefault(),i())})}),e.querySelectorAll(".custom_slick_slider,.rt-swiper .swiper-wrapper,.flow-ritual__mobile .swiper-wrapper").forEach(function(e){e.classList.add("hf-native");var t=e.closest("[data-review-panel]")||e.closest(".rt-shell,.flow-ritual__mobile")||e.parentNode.parentNode,o=t.querySelector(".custom_prev,.rt-nav-btn-prev,.flow-ritual__arrow--prev"),r=t.querySelector(".custom_next,.rt-nav-btn-next,.flow-ritual__arrow--next"),i=t.querySelector(".slider_dots_custom"),l=Array.from(e.children);function a(t){var o=l[0]?l[0].getBoundingClientRect().width+20:300,r=e.scrollLeft+t*o;r>e.scrollWidth-e.clientWidth+10&&(r=0),r<0&&(r=e.scrollWidth),e.scrollTo({left:r,behavior:matchMedia("(prefers-reduced-motion:reduce)").matches?"auto":"smooth"})}if(o&&(o.onclick=function(){a(-1)}),r&&(r.onclick=function(){a(1)}),i){function c(){var t=l[0]?l[0].getBoundingClientRect().width+20:300,o=Math.round(e.scrollLeft/t);Array.from(i.children).forEach(function(e,t){e.classList.toggle("active",t===o)})}i.innerHTML="",l.forEach(function(t,o){var r=document.createElement("button");r.setAttribute("aria-label","Slide "+(o+1)),r.onclick=function(){e.scrollTo({left:t.offsetLeft-e.offsetLeft,behavior:"smooth"})},i.appendChild(r)}),e.onscroll=c,c()}}),e.querySelectorAll("video").forEach(function(e){e.controls=!0;var t=e.closest(".video_wrapper_custom");if(t){var o=t.querySelector(".custom_button");o&&(o.onclick=function(){t.classList.add("video-active"),e.play()})}}),e.querySelectorAll(".count_js").forEach(function(e){e.textContent=e.dataset.value||e.textContent}))}customElements.get("herbalia-liquid-12")||customElements.define("herbalia-liquid-12",class extends HTMLElement{connectedCallback(){var t=this;requestAnimationFrame(function(){e(t)})}}),document.querySelectorAll("herbalia-liquid-12").forEach(e)}();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-dr-resenas-tabs"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.hfReviewsReady)return;root.dataset.hfReviewsReady='1';
    var panels=Array.prototype.slice.call(root.querySelectorAll('[data-review-panel]'));
    var tabs=Array.prototype.slice.call(root.querySelectorAll('[data-review-tab]'));
    var states=[],frame=0;
    function motion(){return window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth';}
    function targets(state){
      var maximum=Math.max(0,state.track.scrollWidth-state.track.clientWidth),start=state.cards[0]?state.cards[0].getBoundingClientRect().left:0,points=[0];
      state.cards.forEach(function(card){var x=Math.min(maximum,Math.max(0,Math.round(card.getBoundingClientRect().left-start)));if(x>points[points.length-1]+2)points.push(x);});
      return points;
    }
    function paint(){
      frame=0;if(!root.isConnected)return;
      states.forEach(function(state){
        if(state.panel.hidden||!state.track.clientWidth)return;
        state.points=targets(state);
        if(state.dots&&state.dots.children.length!==state.points.length){
          state.dots.textContent='';state.points.forEach(function(point,index){var button=document.createElement('button');button.type='button';button.setAttribute('aria-label','Ver reseña '+(index+1));button.addEventListener('click',function(){move(state,index);});state.dots.appendChild(button);});
        }
        var closest=0;state.points.forEach(function(point,index){if(Math.abs(point-state.track.scrollLeft)<Math.abs(state.points[closest]-state.track.scrollLeft))closest=index;});state.index=closest;
        if(state.dots)Array.prototype.forEach.call(state.dots.children,function(button,index){button.classList.toggle('active',index===closest);button.setAttribute('aria-current',index===closest?'true':'false');});

        [state.prev,state.next].forEach(function(button){if(button)button.setAttribute('aria-disabled',state.points.length<2?'true':'false');});
      });
    }
    function schedule(){if(!frame)frame=requestAnimationFrame(paint);}
    function move(state,index){state.points=targets(state);if(!state.points.length)return;index=(index+state.points.length)%state.points.length;state.track.scrollTo({left:state.points[index],behavior:motion()});schedule();}
    panels.forEach(function(panel){
      var track=panel.querySelector('.custom_slick_slider');if(!track)return;
      track.classList.add('hf-native');var state={panel:panel,track:track,cards:Array.prototype.slice.call(track.children),dots:panel.querySelector('.slider_dots_custom'),prev:panel.querySelector('.custom_prev'),next:panel.querySelector('.custom_next'),points:[0],index:0};states.push(state);
      [[state.prev,-1,'Reseña anterior'],[state.next,1,'Reseña siguiente']].forEach(function(item){var button=item[0];if(!button)return;button.setAttribute('role','button');button.setAttribute('tabindex','0');button.setAttribute('aria-label',item[2]);button.addEventListener('click',function(){move(state,state.index+item[1]);});button.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();move(state,state.index+item[1]);}});});
      track.addEventListener('scroll',schedule,{passive:true});
    });
    function select(tab){tabs.forEach(function(t){var active=t===tab;t.classList.toggle('active',active);t.setAttribute('aria-selected',String(active));});panels.forEach(function(panel){var active=panel.dataset.reviewPanel===tab.dataset.reviewTab;panel.classList.toggle('active',active);panel.hidden=!active;});schedule();}
    tabs.forEach(function(tab){tab.addEventListener('click',function(){select(tab);});});
    if(tabs.length)select(tabs.filter(function(t){return t.classList.contains('active');})[0]||tabs[0]);
    root.querySelectorAll('img').forEach(function(img){img.addEventListener('load',schedule);});
    window.addEventListener('resize',schedule);if(document.fonts)document.fonts.ready.then(schedule);
    var observer;if(window.ResizeObserver){observer=new ResizeObserver(schedule);states.forEach(function(state){observer.observe(state.track);state.cards.forEach(function(card){observer.observe(card);});});}
    root.hfReviewsCleanup=function(){window.removeEventListener('resize',schedule);if(observer)observer.disconnect();if(frame)cancelAnimationFrame(frame);};schedule();
  }
  function start(scope){if(scope.matches&&scope.matches('herbalia-liquid-04'))init(scope);scope.querySelectorAll('herbalia-liquid-04').forEach(init);}
  start(document);document.addEventListener('shopify:section:load',function(e){start(e.target);});document.addEventListener('shopify:section:unload',function(e){e.target.querySelectorAll('herbalia-liquid-04').forEach(function(root){if(root.hfReviewsCleanup)root.hfReviewsCleanup();});});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-dr-resultados"] && !Shopify.designMode) return;
  try {
    

(function(){
 function init(sec){
  if(sec.hfCountCleanup)return;
  var cards=Array.prototype.slice.call(sec.querySelectorAll('.results_icons .icons_with_text_item'));
  var frames=new Map(),observer=null,pending=0,stopped=false;
  var reduced=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  cards.forEach(function(card){card.removeAttribute('data-hb-counted');card.querySelectorAll('.hb-result-count').forEach(function(n){n.textContent='0';});});
  function run(card){
   if(card.dataset.hbCounted||stopped)return;
   card.dataset.hbCounted='1';if(observer)observer.unobserve(card);
   var nums=Array.prototype.slice.call(card.querySelectorAll('.hb-result-count'));
   if(reduced){nums.forEach(function(n){n.textContent=n.dataset.value;});return;}
   var start=performance.now();
   function tick(now){
    if(stopped||!sec.isConnected)return;
    var progress=Math.min(1,(now-start)/1600),ease=1-Math.pow(1-progress,3);
    nums.forEach(function(n){n.textContent=String(Math.round(Number(n.dataset.value||0)*ease));});
    if(progress<1)frames.set(card,requestAnimationFrame(tick));else frames.delete(card);
   }
   frames.set(card,requestAnimationFrame(tick));
  }
  function check(){pending=0;if(document.hidden)return;cards.forEach(function(card){var b=card.getBoundingClientRect();var visible=Math.min(b.bottom,window.innerHeight*.9)-Math.max(b.top,0);if(b.width&&visible>=b.height*.65)run(card);});}
  function schedule(){if(!pending)pending=requestAnimationFrame(check);}
  if(window.IntersectionObserver){observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting&&entry.intersectionRatio>=.65&&!document.hidden)run(entry.target);});},{threshold:[.65],rootMargin:'0px 0px -10% 0px'});cards.forEach(function(card){observer.observe(card);});}
  else{window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);schedule();}
  document.addEventListener('visibilitychange',schedule);
  sec.hfCountCleanup=function(){document.removeEventListener('visibilitychange',schedule);stopped=true;if(observer)observer.disconnect();window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);if(pending)cancelAnimationFrame(pending);frames.forEach(function(id){cancelAnimationFrame(id);});frames.clear();sec.hfCountCleanup=null;};
 }
 if(!customElements.get('herbalia-liquid-09'))customElements.define('herbalia-liquid-09',class extends HTMLElement{connectedCallback(){var sec=this;requestAnimationFrame(function(){if(sec.isConnected)init(sec);});}disconnectedCallback(){if(this.hfCountCleanup)this.hfCountCleanup();}});
 document.querySelectorAll('herbalia-liquid-09').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-dr-ritual"] && !Shopify.designMode) return;
  try {
    
!function(){function e(e){e.dataset.hfMounted||(e.dataset.hfMounted="1",e.querySelectorAll("[data-review-tab]").forEach(function(t){t.onclick=function(){e.querySelectorAll("[data-review-tab]").forEach(function(e){e.classList.toggle("active",e===t),e.setAttribute("aria-selected",e===t)}),e.querySelectorAll("[data-review-panel]").forEach(function(e){e.classList.toggle("active",e.dataset.reviewPanel===t.dataset.reviewTab)})}}),e.querySelectorAll(".section3_icons_lp .icons_with_text_item,.faq_slider_item").forEach(function(t){var o=t.querySelector(".icons_with_text_item_flex,.faq_question"),r=t.querySelector(".icons_with_text_item_text,.faq_answer");function i(){var r=!t.classList.contains("active");e.querySelectorAll(".section3_icons_lp .icons_with_text_item,.faq_slider_item").forEach(function(e){e.classList.remove("active");var t=e.querySelector("[role=button]");t&&t.setAttribute("aria-expanded","false")}),t.classList.toggle("active",r),o.setAttribute("aria-expanded",r)}o&&r&&(o.setAttribute("role","button"),o.setAttribute("tabindex","0"),o.setAttribute("aria-expanded","false"),o.onclick=i,o.onkeydown=function(e){"Enter"!==e.key&&" "!==e.key||(e.preventDefault(),i())})}),e.querySelectorAll(".custom_slick_slider,.rt-swiper .swiper-wrapper,.flow-ritual__mobile .swiper-wrapper").forEach(function(e){e.classList.add("hf-native");var t=e.closest("[data-review-panel]")||e.closest(".rt-shell,.flow-ritual__mobile")||e.parentNode.parentNode,o=t.querySelector(".custom_prev,.rt-nav-btn-prev,.flow-ritual__arrow--prev"),r=t.querySelector(".custom_next,.rt-nav-btn-next,.flow-ritual__arrow--next"),i=t.querySelector(".slider_dots_custom"),l=Array.from(e.children);function a(t){var o=l[0]?l[0].getBoundingClientRect().width+20:300,r=e.scrollLeft+t*o;r>e.scrollWidth-e.clientWidth+10&&(r=0),r<0&&(r=e.scrollWidth),e.scrollTo({left:r,behavior:matchMedia("(prefers-reduced-motion:reduce)").matches?"auto":"smooth"})}if(o&&(o.onclick=function(){a(-1)}),r&&(r.onclick=function(){a(1)}),i){function c(){var t=l[0]?l[0].getBoundingClientRect().width+20:300,o=Math.round(e.scrollLeft/t);Array.from(i.children).forEach(function(e,t){e.classList.toggle("active",t===o)})}i.innerHTML="",l.forEach(function(t,o){var r=document.createElement("button");r.setAttribute("aria-label","Slide "+(o+1)),r.onclick=function(){e.scrollTo({left:t.offsetLeft-e.offsetLeft,behavior:"smooth"})},i.appendChild(r)}),e.onscroll=c,c()}}),e.querySelectorAll("video").forEach(function(e){e.controls=!0;var t=e.closest(".video_wrapper_custom");if(t){var o=t.querySelector(".custom_button");o&&(o.onclick=function(){t.classList.add("video-active"),e.play()})}}),e.querySelectorAll(".count_js").forEach(function(e){e.textContent=e.dataset.value||e.textContent}))}customElements.get("herbalia-liquid-05")||customElements.define("herbalia-liquid-05",class extends HTMLElement{connectedCallback(){var t=this;requestAnimationFrame(function(){e(t)})}}),document.querySelectorAll("herbalia-liquid-05").forEach(e)}();
(function(){function init(s){var track=s.querySelector('.flow-ritual__mobile .swiper-wrapper');if(!track||track.dataset.ritualHeight)return;track.dataset.ritualHeight='1';var pending=false;function fit(){pending=false;if(!matchMedia('(max-width:915px)').matches){track.style.removeProperty('height');return}var cards=Array.prototype.slice.call(track.children);var active=cards.reduce(function(a,b){return Math.abs(b.offsetLeft-track.offsetLeft-track.scrollLeft)<Math.abs(a.offsetLeft-track.offsetLeft-track.scrollLeft)?b:a},cards[0]);if(active)track.style.setProperty('height',Math.ceil(active.getBoundingClientRect().height)+'px','important')}function update(){if(!pending){pending=true;requestAnimationFrame(fit)}}track.addEventListener('scroll',update);window.addEventListener('resize',update);s.querySelectorAll('img').forEach(function(im){im.addEventListener('load',update)});if(window.ResizeObserver)new ResizeObserver(update).observe(track.children[0]);update()}document.querySelectorAll('herbalia-liquid-05').forEach(init);document.addEventListener('shopify:section:load',function(e){e.target.querySelectorAll('herbalia-liquid-05').forEach(init)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-dr-semanas"] && !Shopify.designMode) return;
  try {
    
(function(){function init(sec){if(sec.hfTimelineCleanup)return;sec.dataset.hfMounted='1';var items=Array.prototype.slice.call(sec.querySelectorAll('.timeline_icons .icons_with_text_item'));var frame=0;function paint(){frame=0;var threshold=window.innerHeight/2+100;items.forEach(function(item){item.classList.toggle('active',item.getBoundingClientRect().top<=threshold)})}function schedule(){if(!frame)frame=requestAnimationFrame(paint)}window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);sec.querySelectorAll('img').forEach(function(img){img.addEventListener('load',schedule)});paint();sec.hfTimelineCleanup=function(){window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);if(frame)cancelAnimationFrame(frame);sec.querySelectorAll('img').forEach(function(img){img.removeEventListener('load',schedule)});sec.hfTimelineCleanup=null;delete sec.dataset.hfMounted}}if(!customElements.get('herbalia-liquid-11'))customElements.define('herbalia-liquid-11',class extends HTMLElement{connectedCallback(){var sec=this;requestAnimationFrame(function(){if(sec.isConnected)init(sec)})}disconnectedCallback(){if(this.hfTimelineCleanup)this.hfTimelineCleanup()}});document.querySelectorAll('herbalia-liquid-11').forEach(init)})();
(function(){function init(){document.querySelectorAll('herbalia-liquid-11').forEach(function(root){if(root.dataset.hfLineAligned)return;root.dataset.hfLineAligned='1';var cards=Array.prototype.slice.call(root.querySelectorAll('.timeline_icons .icons_with_text_item'));function align(){cards.forEach(function(card,i){var head=card.querySelector('.icon_svg_main'),next=cards[i+1]&&cards[i+1].querySelector('.icon_svg_main');if(head){card.style.setProperty('--hf11-anchor',(head.offsetHeight/2)+'px');card.style.setProperty('--hf11-next-anchor',((next?next.offsetHeight:head.offsetHeight)/2)+'px');}});}if(window.ResizeObserver){var ro=new ResizeObserver(align);cards.forEach(function(card){var head=card.querySelector('.icon_svg_main');if(head)ro.observe(head);});}window.addEventListener('resize',align);if(document.fonts)document.fonts.ready.then(align);requestAnimationFrame(align);});}init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-dr-testimonios"] && !Shopify.designMode) return;
  try {
    
(function(){function init(sec){if(sec.hfReviewCleanup)return;sec.dataset.hfMounted='1';var track=sec.querySelector('.rt-swiper .swiper-wrapper'),cards=Array.prototype.slice.call(track.children),index=0,pending=0,reduced=window.matchMedia('(prefers-reduced-motion:reduce)').matches;function left(i){return Math.max(0,cards[i].offsetLeft+cards[i].offsetWidth/2-track.clientWidth/2)}function active(i){index=i;cards.forEach(function(c,n){c.classList.toggle('hf-active',n===i)})}function update(){pending=0;var best=Infinity,nearest=0;cards.forEach(function(c,i){var d=Math.abs(track.scrollLeft-left(i));if(d<best){best=d;nearest=i}});active(nearest)}function schedule(){if(!pending)pending=requestAnimationFrame(update)}function go(d){index=(index+d+cards.length)%cards.length;active(index);track.scrollTo({left:left(index),behavior:reduced?'auto':'smooth'})}var prev=sec.querySelector('.rt-nav-btn-prev'),next=sec.querySelector('.rt-nav-btn-next');prev.onclick=function(){go(-1)};next.onclick=function(){go(1)};track.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);active(0);sec.hfReviewCleanup=function(){track.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);if(pending)cancelAnimationFrame(pending);sec.hfReviewCleanup=null;delete sec.dataset.hfMounted}}if(!customElements.get('herbalia-liquid-16'))customElements.define('herbalia-liquid-16',class extends HTMLElement{connectedCallback(){var sec=this;requestAnimationFrame(function(){if(sec.isConnected)init(sec)})}disconnectedCallback(){if(this.hfReviewCleanup)this.hfReviewCleanup()}});document.querySelectorAll('herbalia-liquid-16').forEach(init)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-home-beneficios"] && !Shopify.designMode) return;
  try {
    
function hbInithbhomebeneficios(){
  (function(){
    document.querySelectorAll('.mv-ben').forEach(function(sec){
      if (sec.dataset.mvBenInit) return;   /* evita inicializar dos veces */
      sec.dataset.mvBenInit = '1';

      var tabs  = Array.prototype.slice.call(sec.querySelectorAll('[data-mv-tab]'));
      var image = sec.querySelector('[data-mv-image]');
      if (!tabs.length || !image) return;

      var token   = 0;
      var lastSrc = image.getAttribute('src');
      var cache   = {};

      function preload(src){
        if (cache[src]) return cache[src];
        cache[src] = new Promise(function(resolve, reject){
          var im = new Image();
          im.onload  = function(){ resolve(im); };
          im.onerror = reject;
          im.src = src;
        });
        return cache[src];
      }

      /* Precarga las imágenes de todas las pestañas */
      tabs.forEach(function(t){
        if (t.dataset.image) preload(t.dataset.image).then(null, function(){});
      });

      function swap(src, requestId){
        preload(src).then(function(){
          if (requestId !== token) return;
          image.classList.add('is-changing');
          window.setTimeout(function(){
            if (requestId !== token) return;
            image.src = src;
            lastSrc = src;
            requestAnimationFrame(function(){
              requestAnimationFrame(function(){
                if (requestId === token) image.classList.remove('is-changing');
              });
            });
          }, 140);
        }, function(){
          if (requestId !== token) return;
          image.src = src;
          lastSrc = src;
          image.classList.remove('is-changing');
        });
      }

      tabs.forEach(function(tab){
        tab.addEventListener('click', function(){
          if (tab.classList.contains('is-active')) return;

          tabs.forEach(function(t){
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });

          var src = tab.dataset.image;
          if (!src || src === lastSrc) return;
          token += 1;
          swap(src, token);
        });
      });
    });
  })();
}
hbInithbhomebeneficios();
document.addEventListener("shopify:section:load",hbInithbhomebeneficios);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-home-preguntas"] && !Shopify.designMode) return;
  try {
    
function hbInithbhomepreguntas(){
  (function(){
    document.querySelectorAll('.mv-faq').forEach(function(sec){
      if (sec.dataset.mvFaqInit) return;   /* evita inicializar dos veces */
      sec.dataset.mvFaqInit = '1';


      var items = Array.prototype.slice.call(sec.querySelectorAll('[data-mv-faq]'));
      if (!items.length) return;


      function openItem(item){
        var trigger = item.querySelector('[data-mv-trigger]');
        var content = item.querySelector('[data-mv-content]');
        if (!trigger || !content) return;


        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');


        content.style.height = '0px';
        requestAnimationFrame(function(){
          content.style.height = content.scrollHeight + 'px';
        });


        function onEnd(event){
          if (event.propertyName !== 'height') return;
          if (item.classList.contains('is-open')) content.style.height = 'auto';
          content.removeEventListener('transitionend', onEnd);
        }
        content.addEventListener('transitionend', onEnd);
      }


      function closeItem(item){
        var trigger = item.querySelector('[data-mv-trigger]');
        var content = item.querySelector('[data-mv-content]');
        if (!trigger || !content || !item.classList.contains('is-open')) return;


        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(function(){
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          content.style.height = '0px';
        });
      }


      items.forEach(function(item){
        var trigger = item.querySelector('[data-mv-trigger]');
        var content = item.querySelector('[data-mv-content]');
        if (!trigger || !content) return;


        /* Estado inicial */
        if (item.classList.contains('is-open')) {
          content.style.height = 'auto';
          trigger.setAttribute('aria-expanded', 'true');
        } else {
          content.style.height = '0px';
          trigger.setAttribute('aria-expanded', 'false');
        }


        trigger.addEventListener('click', function(){
          var alreadyOpen = item.classList.contains('is-open');


          items.forEach(function(other){
            if (other !== item) closeItem(other);
          });


          if (alreadyOpen) { closeItem(item); }
          else { openItem(item); }
        });
      });


      window.addEventListener('resize', function(){
        items.forEach(function(item){
          var content = item.querySelector('[data-mv-content]');
          if (item.classList.contains('is-open') && content) content.style.height = 'auto';
        });
      });
    });
  })();
}
hbInithbhomepreguntas();
document.addEventListener("shopify:section:load",hbInithbhomepreguntas);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-home-resenas"] && !Shopify.designMode) return;
  try {
    
function hbInithbhomeresenas(){
  (function(){
    document.querySelectorAll('.mv-esp').forEach(function(sec){
      if (sec.dataset.mvEspInit) return;   /* evita inicializar dos veces */
      sec.dataset.mvEspInit = '1';

      var track = sec.querySelector('.mv-esp__track');
      var prev  = sec.querySelector('.mv-esp__arrow--prev');
      var next  = sec.querySelector('.mv-esp__arrow--next');
      var dotsC = sec.querySelector('.mv-esp__dots');
      if (!track || !prev || !next || !dotsC) return;

      var cards = Array.prototype.slice.call(track.querySelectorAll('.mv-esp__card'));
      if (!cards.length) return;

      var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      /* --- Re-encaje: si un toque frena el carrusel a mitad, vuelve a encajar en una tarjeta --- */
      (function(){
        var pistaR = sec.querySelector('.mv-esp__track');
        if (!pistaR) return;
        var tocandoR = false, timerR = null;
        function reencajar(){
          if (tocandoR) return;
          var tarjetas = pistaR.querySelectorAll('.mv-esp__card');
          if (!tarjetas.length) return;
          var maxX = pistaR.scrollWidth - pistaR.clientWidth;
          if (maxX <= 2) return;                     /* sin scroll (escritorio en rejilla) */
          var x = pistaR.scrollLeft, mejor = 0, dist = Infinity;
          for (var i = 0; i < tarjetas.length; i++){
            var d = Math.abs(tarjetas[i].offsetLeft - x);
            if (d < dist){ dist = d; mejor = i; }
          }
          if (dist <= 2 || Math.abs(maxX - x) <= 2) return;   /* ya está encajada */
          pistaR.scrollTo({left: Math.min(tarjetas[mejor].offsetLeft, maxX), behavior: behavior});
        }
        function programar(){ clearTimeout(timerR); timerR = setTimeout(reencajar, 160); }
        pistaR.addEventListener('scroll', programar, {passive:true});
        pistaR.addEventListener('pointerdown', function(){ tocandoR = true; clearTimeout(timerR); }, {passive:true});
        window.addEventListener('pointerup', function(){ tocandoR = false; programar(); }, {passive:true});
        pistaR.addEventListener('pointercancel', function(){ tocandoR = false; programar(); }, {passive:true});
      })();

      /* Crea un punto por reseña */
      var dots = cards.map(function(_, i){
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'mv-esp__dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Ir a la reseña ' + (i + 1));
        d.addEventListener('click', function(){ goTo(i); });
        dotsC.appendChild(d);
        return d;
      });

      function step(){
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return cards[0].getBoundingClientRect().width + gap;
      }
      function atStart(){ return track.scrollLeft <= 4; }
      function atEnd(){ return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
      function current(){
        var i = Math.round(track.scrollLeft / step());
        if (atEnd()) i = cards.length - 1;
        return Math.max(0, Math.min(cards.length - 1, i));
      }
      function goTo(i){
        i = Math.max(0, Math.min(cards.length - 1, i));
        track.scrollTo({left: cards[i].offsetLeft, behavior: behavior});
      }
      function paint(){
        var i = current();
        dots.forEach(function(d, k){ d.classList.toggle('is-active', k === i); });
      }

      prev.addEventListener('click', function(){
        if (atStart()) { goTo(cards.length - 1); }
        else { goTo(current() - 1); }
      });
      next.addEventListener('click', function(){
        if (atEnd()) { goTo(0); }
        else { goTo(current() + 1); }
      });

      var ticking = false;
      track.addEventListener('scroll', function(){
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function(){ paint(); ticking = false; });
      }, {passive:true});
    });
  })();
}
hbInithbhomeresenas();
document.addEventListener("shopify:section:load",hbInithbhomeresenas);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-home-ritual"] && !Shopify.designMode) return;
  try {
    
function hbInithbhomeritual(){
  (function(){
    document.querySelectorAll('.mv-rit').forEach(function(sec){
      if (sec.dataset.mvRitInit) return;   /* evita inicializar dos veces */
      sec.dataset.mvRitInit = '1';

      var track = sec.querySelector('.mv-rit__grid');
      var prev  = sec.querySelector('.mv-rit__arrow--prev');
      var next  = sec.querySelector('.mv-rit__arrow--next');
      if (!track || !prev || !next) return;

      var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      /* --- Re-encaje: si un toque frena el carrusel a mitad, vuelve a encajar en una tarjeta --- */
      (function(){
        var pistaR = sec.querySelector('.mv-rit__grid');
        if (!pistaR) return;
        var tocandoR = false, timerR = null;
        function reencajar(){
          if (tocandoR) return;
          var tarjetas = pistaR.querySelectorAll('.mv-rit__slide');
          if (!tarjetas.length) return;
          var maxX = pistaR.scrollWidth - pistaR.clientWidth;
          if (maxX <= 2) return;                     /* sin scroll (escritorio en rejilla) */
          var x = pistaR.scrollLeft, mejor = 0, dist = Infinity;
          for (var i = 0; i < tarjetas.length; i++){
            var d = Math.abs(tarjetas[i].offsetLeft - x);
            if (d < dist){ dist = d; mejor = i; }
          }
          if (dist <= 2 || Math.abs(maxX - x) <= 2) return;   /* ya está encajada */
          pistaR.scrollTo({left: Math.min(tarjetas[mejor].offsetLeft, maxX), behavior: behavior});
        }
        function programar(){ clearTimeout(timerR); timerR = setTimeout(reencajar, 160); }
        pistaR.addEventListener('scroll', programar, {passive:true});
        pistaR.addEventListener('pointerdown', function(){ tocandoR = true; clearTimeout(timerR); }, {passive:true});
        window.addEventListener('pointerup', function(){ tocandoR = false; programar(); }, {passive:true});
        pistaR.addEventListener('pointercancel', function(){ tocandoR = false; programar(); }, {passive:true});
      })();

      function step(){
        var slide = track.querySelector('.mv-rit__slide');
        if (!slide) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return slide.getBoundingClientRect().width + gap;
      }
      function atStart(){ return track.scrollLeft <= 4; }
      function atEnd(){ return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }

      prev.addEventListener('click', function(){
        if (atStart()) { track.scrollTo({left: track.scrollWidth, behavior: behavior}); }
        else { track.scrollBy({left: -step(), behavior: behavior}); }
      });
      next.addEventListener('click', function(){
        if (atEnd()) { track.scrollTo({left: 0, behavior: behavior}); }
        else { track.scrollBy({left: step(), behavior: behavior}); }
      });
    });
  })();
}
hbInithbhomeritual();
document.addEventListener("shopify:section:load",hbInithbhomeritual);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
